import { Texture } from "@pixi/core";
import { Sprite } from "@pixi/sprite";
import { ICanvasScaler } from "by/gamefactory/canvas/ICanvasScaler";
import { IDestroyOptions, Point, Text, TextStyle } from "pixi.js";
import { GameFont } from "by/gamefactory/cityversetycoon/scenes/common/GameFont";
import { PromiseCompletionSource } from "by/gamefactory/shared/async/PromiseCompletionSource";
import { Avatar } from "by/gamefactory/cityversetycoon/scenes/common/components/Avatar";
import { UserProfileResourcePackage } from "by/gamefactory/cityversetycoon/scenes/popups/userprofile/resources/UserProfileResourcePackage";

export abstract class NewsCardView extends Sprite {
    protected readonly canvasScaler: ICanvasScaler;
    protected readonly avatar: Avatar;
    protected readonly guestNameText: Text;
    protected readonly messageText: Text;

    public constructor(
        background: Texture,
        userProfileResources: UserProfileResourcePackage,
        guestAvatar: Texture,
        guestName: string,
        message: string,
        canvasScaler: ICanvasScaler
    ) {
        super(background);
        this.avatar = new Avatar(userProfileResources, guestAvatar);
        this.avatar.avatarSize = new Point(70, 70);
        this.avatar.enabled = false;
        this.avatar.glow = true;
        const textStyle = new NewsCardViewTextStyle();
        this.guestNameText = new Text(guestName, textStyle);
        this.messageText = new Text(message, textStyle);
        this.addChild(this.avatar, this.guestNameText, this.messageText);
        this.canvasScaler = canvasScaler;
        this.canvasScaler.onResize.add(this.layout, this);
        this.layoutData();
    }

    private layout(): void {
        if (this.parent == null) {
            return;
        }
        const topLeft = this.parent.toLocal({ x: 0, y: 0 });
        this.position.y = topLeft.y;
    }

    // We have some inconsistency in art. Will define this method for future sibling override. 
    protected abstract layoutData(): void;

    public abstract accrueResult(waitForComplete: PromiseCompletionSource<void>): void;

    public override destroy(options?: boolean | IDestroyOptions): void {
        this.canvasScaler.onResize.remove(this.layout, this);
        super.destroy(options);
    }
}

export class NewsCardViewTextStyle extends TextStyle {
    public constructor() {
        super({
            fill: 0xffffff,
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 56
        });
    }
}
